import {
  Box,
  useTheme,
  IconButton,
  TextField,
  styled,
  FormHelperText,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { tokens } from "../../theme";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import React from "react";
import { DateRange } from "@mui/icons-material";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";

import { initializeEncryption } from "../../services/AesGcmEncryption";
import { Radio, RadioGroup } from "@mui/material";
import { Stack } from "@mui/material";
import { InputLabel, Select, MenuItem } from "@mui/material";
import { Search } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";

import CustomButton from "../../components/CustomButton";
import { useEffect, useState } from "react";
import { selectedItems, showErrorAlertDialog } from "../../config/AppConfig";
import { useAtom } from "jotai";
import DebugLog from "../../utils/DebugLog";
import { FormControl, FormControlLabel } from "@mui/material";
import DatePickerDialog from "../../components/DatePickerDialog";
import CustomDatePickerDialog from "../../components/DatePickerDialog";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  getAdjustmentDescriptionDropdownDetails,
  updateDebitCreditDetails,
} from "../../services/ApiService";
import { getFromLocalStorage } from "../../utils/localStorageUtils";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import {
  ALERT,
  ERROR,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  SOME_ERROR_OCCURRED,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import { generateRequestId } from "../../utils/RequestIdGenerator";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import ConnectionStatus from "../../utils/ConnectionStatus";
import * as CONSTANT from "../../constants/Constant";
import CancelAdjustment from "./CancelAdjustment";

const AddAdjustments = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);

  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [checked, setChecked] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState("option1");
  const dropdownHeight = "400px"; // Set the desired height

  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");

  // Retrieve location state
  const location = useLocation();
  const dataProps = location.state && location.state.data;
  const flowProp = location.state && location.state.type;
  const searchDataProps = location.state && location.state.searchData;

  const [loading, setLoading] = useState(false);
  const [isScheduledRadioSelected, setIsScheduledRadioSelected] = useState(false);
  const [isImmediateRadioSelected, setIsImmediateRadioSelected] = useState(false);
  const [editAllowed, setEditAllowed] = useState(false);

  // dropdown state
  const [selectedtypedropdownValue, setTypeDropdownValue] = useState("");
  const [selectedDescriptionDropdown, setSelectedDescription] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");
  const [
    creditDebitDescriptionDropdownDetails,
    setCreditDebitDescriptionDropdownDetails,
  ] = useState([]);
  const [searchDealer, setSearchDealer] = useState([]);
  const decimalPattern = /^\d*\.?\d*$/;
  const [openCancelAdjustmentDialog, setOpenCancelAdjustmentDialog] =
    useState(false);

  // const classes = useStyles();
  const [formData, setFormData] = useState({
    dealer: "",
    type: "",
    description: "",
    amount: "",
    option: "",
    date: "",
    refrenceNo: "",
    id: "",
    reason: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    updateFormData();
  }, []);


  useEffect(() => {
    DebugLog(JSON.stringify({ dataProps }));
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate]);

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  function updateFormData() {
    DebugLog("dataProps from Add Adjustment  " + JSON.stringify({ dataProps }));

    if (dataProps !== null && dataProps.type !== null) {
      setDate(dataProps.date);
      setEditAllowed(dataProps.isEditable);

      const selectedType = selectMatchingTypeDropdownValue(dataProps.type, 0);
      const selectedDescription = selectMatchingTypeDropdownValue(
        dataProps.details,
        1
      );
      const postingRadioOptions = selectMatchingTypeDropdownValue(
        dataProps.status,
        2
      );

      const value = {
        dealer: dataProps.name != null ? dataProps.name : "",
        type: selectedType,
        description: selectedDescription,
        amount: dataProps.amount != null ? dataProps.amount : "",
        option: postingRadioOptions,
        date: selectedDate,
        refrenceNo: dataProps.referenceNo != null ? dataProps.referenceNo : "",
        reason: dataProps.reason != null ? dataProps.reason : "",
        id: dataProps.id != null ? dataProps.id : "",
      };
      DebugLog(JSON.stringify({ value }));

      setFormData(value);
    } else {
      setEditAllowed(true);
    }
  }

  // Function to loop through options and select the matching value
  const selectMatchingTypeDropdownValue = (valueToMatch, dropdownType) => {
    // let match  = ""
    if (dropdownType === 0) {
      const match = CONSTANT.typeOptions.find(
        (option) => option.label.toLowerCase() === valueToMatch.toLowerCase()
      );
      if (match) {
        return match.value;
      }
    } else if (dropdownType === 1) {
      const match = CONSTANT.descriptionOptions.find(
        (option) => option.label.toLowerCase() === valueToMatch.toLowerCase()
      );
      if (match) {
        return match.value;
      }
    } else if (dropdownType === 2) {
      const match = CONSTANT.postingOptions.find(
        (option) => option.value.toLowerCase() === valueToMatch.toLowerCase()
      );
      if (match) {
        return match.value;
      }
    }
    return "";
  };

  // Function to loop through options and select the matching value
  const selectMatchingTypeDropdown = (valueToMatch, dropdownType) => {
    // let match  = ""
    if (dropdownType === 0) {
      const match = CONSTANT.typeOptions.find(
        (option) => option.value.toLowerCase() === valueToMatch.toLowerCase()
      );
      if (match) {
        return match.label;
      }
    } else if (dropdownType === 1) {
      const match = CONSTANT.descriptionOptions.find(
        (option) => option.value.toLowerCase() === valueToMatch.toLowerCase()
      );
      if (match) {
        return match.label;
      }
    } else if (dropdownType === 2) {
      const match = CONSTANT.postingOptions.find(
        (option) => option.value.toLowerCase() === valueToMatch.toLowerCase()
      );
      if (match) {
        return match.label;
      }
    }
    return "";
  };

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  function getAdjustmentDescDropdownsValue() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          // pageNumber: 0,
          // pageSize: 100,
          // searchType:"NONE",
          // searchKeyword:'',
          // isDateRangeProvided:false
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_LIST_OF_DESCRIPTION_DROPDOWN_CREDIT_DEBIT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          getAdjustmentDescriptionDropdownDetails(requestData)
            .then((response) => {
              // setCreditDebitDescriptionDropdownDetails(
              //   response.data.result.descriptions
              // );

              const descriptionDropdown = []

              const model =  { value: "", label: "Select an option" }
              descriptionDropdown.push(model)

              for(let i=0;i< response.data.result.descriptions.length;i++){
               
                const model = {
                  value: i,
                  label: response.data.result.descriptions[i]
                }

                descriptionDropdown.push(model)
              }

              setCreditDebitDescriptionDropdownDetails(
                response.data.result.descriptions
              );


// export const descriptionOptions = [
//   { value: "", label: "Select an option" },
//   { value: "description1", label: "Rental" },
//   { value: "description2", label: "Fraud Case" },
//   { value: "description3", label: "Clawback incentive" },
//   { value: "description4", label: "Clawback device" },
//   { value: "description5", label: "Double Payment for Incentive" },
//   { value: "description6", label: "Double Payment for device reimbursement" },
//   { value: "description7", label: "Double Bill Payment/ Reload / Add On" },
//   { value: "description8", label: "Electricity" },
//   { value: "description9", label: "Others" }
// ];

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                error.data != null
                  ? error.data.displayErrorMessage
                  : SOME_ERROR_OCCURRED;

              if (message)
                showErrorAlert(
                  ERROR,
                  ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const setDate = (date) => {
    if (date !== null) {
      setSelectedDate(date);
    } else {
      setTodaysDate();
    }
  };

  const setTodaysDate = () => {
    // Get today's date
    const today = dayjs();
    // Format today's date (optional)
    const formattedDate = today.format("YYYY/MM/DD");
    setSelectedDate(formattedDate);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    DebugLog("Dialog Closed");
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    DebugLog("Selected Date " + selectedDate);
  };

  const dropdownStyle = {
    maxHeight: dropdownHeight,
    overflowY: "auto", // Add a scrollbar if needed
  };

  const handleInputChange = (e) => {

      if(e.target.value==="scheduled"){
        setIsScheduledRadioSelected(true)
        setIsImmediateRadioSelected(false)
      }else if(e.target.value==="posted"){
        setIsScheduledRadioSelected(false)
        setIsImmediateRadioSelected(true)
      }
       
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const StyledInputLabel = styled(InputLabel)({
    height: "40px", // Set the desired height for the InputLabel
  });
  const cancelAdjustment = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (!formData.dealer.trim()) {
      newErrors.dealer = "Dealer Name is required";
    }

    if (!formData.type) {
      newErrors.type = "Type is required";
    }

    if (!formData.description) {
      newErrors.description = "Description is required";
    }

    if (!formData.amount) {
      newErrors.amount = "Amount is required";
    }

    if (!decimalPattern.test(formData.amount)) {
      newErrors.amount = "Invalid input: Please enter a valid number";
    }

    formData.date = selectedDate;

    if (!formData.date) {
      newErrors.date = "Please choose Date";
    }

    if (!formData.option) {
      newErrors.option = "Please select Option";
    }

    if (!formData.refrenceNo) {
      newErrors.refrenceNo = "Refrence number is required";
    }

    if (Object.keys(newErrors).length === 0) {
      const typeValue = selectMatchingTypeDropdown(formData.type, 0);
      const descriptionValue = selectMatchingTypeDropdown(
        formData.description,
        1
      );
      const postingOptionValue = selectMatchingTypeDropdown(formData.option, 2);

      let formValue = {};
      formValue = {
        amount: formData.amount,
        date: formData.date,
        dealerCode: dataProps.code,
        dealerName: formData.dealer,
        description: descriptionValue,
        id: dataProps.id,
        posting: postingOptionValue,
        referenceNo: formData.refrenceNo,
        type: typeValue,
      };

      setSelectedItem(formValue);
      setOpenCancelAdjustmentDialog(true);
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  const handleTypeDropdownChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleRadioButtonChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  function chooseDateOptionClicked() {
    setOpen(true);
  }

  const handleCloseDialog = () => {
    setOpenCancelAdjustmentDialog(false);
  };

  function dealerSearchIconClick() {
    DebugLog("flowProp >> " + flowProp);
    if (flowProp === "0") {
      showErrorAlert("Alert", "Dealer Name change is not allowed");
    } else {
      navigate(CONSTANT.SEARCH_DEALER_CREDIT_DEBIT_ROUTE, {
        state: { data: dataProps, type: flowProp },
      });
    }
  }

  function openDatePickerDialog() {
    alert("icon clicked");

    DatePickerDialog();
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    // Validation logic
    const newErrors = {};

    if (!formData.dealer.trim()) {
      newErrors.dealer = "Dealer Name is required";
    }

    if (!formData.type) {
      newErrors.type = "Type is required";
    }

    if (!formData.description) {
      newErrors.description = "Description is required";
    }

    if (!formData.amount) {
      newErrors.amount = "Amount is required";
    }

    if (!decimalPattern.test(formData.amount)) {
      newErrors.amount = "Invalid input: Please enter a valid number";
    }

    formData.date = selectedDate;

    if (!formData.date) {
      newErrors.date = "Please choose Date";
    }

    if (!formData.option) {
      newErrors.option = "Please select Option";
    }

    if (!formData.refrenceNo) {
      newErrors.refrenceNo = "Refrence number is required";
    }

    // if (!formData.reason) {
    //   newErrors.reason = "Reason is required";
    // }
    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data
    

      if (flowProp === "0") {
        updateCreditDebitDetails(formData, 0);
      } else {
        updateCreditDebitDetails(formData, 2);
      }
    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  function dismissDialog() {
    setOpenCancelAdjustmentDialog(false);
  }
  function cancelAdjustmentButtonClicked(data, type) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          id: data.id,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.UPDATE_ADJUSTMENT_CREDIT_DEBIT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          updateDebitCreditDetails(requestData, type)
            .then((response) => {
              if (response.data.responseCode === "0") {
                navigate("/CancelAdjustmentSuccess", {
                  state: { data: data, type: type },
                });
              }

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                  navigate("/");
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  function updateCreditDebitDetails(formData, type) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const typeValue = selectMatchingTypeDropdown(formData.type, 0);
        const descriptionValue = selectMatchingTypeDropdown(
          formData.description,
          1
        );
        const postingOptionValue = selectMatchingTypeDropdown(
          formData.option,
          2
        );

        let requestObject = {};
        if (type === 0) {
          //const formattedDate = formatDate(formData.date);
          requestObject = {
            amount: formData.amount,
            date: formData.date,
            dealerCode: dataProps.code,
            dealerName: formData.dealer,
            description: descriptionValue,
            id: dataProps.id,
            posting: postingOptionValue,
            referenceNo: formData.refrenceNo,
            type: typeValue,
          };
        } else if (type === 1) {
          requestObject = {
            id: dataProps.id,
          };
        } else if (type === 2) {
          requestObject = {
            amount: formData.amount,
            date: formData.date,
            dealerCode: dataProps.code,
            dealerName: formData.dealer,
            description: descriptionValue,
            posting: postingOptionValue,
            referenceNo: formData.refrenceNo,
            type: typeValue,
          };
        }

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.UPDATE_ADJUSTMENT_CREDIT_DEBIT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          updateDebitCreditDetails(requestData, type)
            .then((response) => {
              if (response.data.responseCode === "0") {
                const dataObject = {
                  amount: formData.amount,
                  date: formData.date,
                  dealerCode: dataProps.code,
                  dealer: formData.dealer,
                  description: descriptionValue,
                  id: dataProps.id,
                  posting: postingOptionValue,
                  referenceNo: formData.refrenceNo,
                  type: typeValue,
                };
                navigate("/CancelAdjustmentSuccess", {
                  state: { data: dataObject, type: type },
                });
              }
              dismissDialog();

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else  if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  useEffect(() => {
    if(isScheduledRadioSelected){
      const today = dayjs();
      const oneDayAfter = today.add(1, 'day');
      handleDateSelect(dayjs(oneDayAfter).format('DD/MM/YYYY'))
    }
   
  }, [isScheduledRadioSelected]);

  useEffect(() => {
    if(isImmediateRadioSelected){
    const today = dayjs();
    handleDateSelect(dayjs(today).format('DD/MM/YYYY'))
    }
  }, [isImmediateRadioSelected]);

  
  return (
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />

        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        {/* <Header title="FAQ" subtitle="Frequently Asked Questions Page" /> */}
        {/* <DatePickerDialog />  */}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          <CustomDatePickerDialog
            open={open}
            onClose={handleClose}
            onSelect={handleDateSelect}
            type={formData.option}
          />

          <CancelAdjustment
            open={openCancelAdjustmentDialog}
            onClose={handleCloseDialog}
            cancelAdjustmentButtonClicked={cancelAdjustmentButtonClicked}
            data={selectedItem}
          />
          {/* Header */}
          <Grid container direction={"row"} alignItems={"center"}>
            <Grid item mr={2}>
              <IconButton href="/creditDebit" width={12}>
                <img src={"../../assets/common/Back.svg"} width={12} />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography
                color={colors.grey[100]}
                fontWeight={"600"}
                variant="h3"
              >
                Add Adjustment
              </Typography>
            </Grid>
          </Grid>
          {/* Header */}

          {/* Form Filter */}

          <Grid
            container
            mt={2}
            p={3}
            direction={"column"}
            alignItems={"center"}
            sx={{
              background: colors.grey[900],
              borderRadius: "12px",
            }}
          >
            <Grid item>
              {editAllowed === true ? (
                <Typography
                  color={colors.grey[100]}
                  fontWeight={"700"}
                  variant="h6"
                >
                  Please provide details
                </Typography>
              ) : (
                <Typography
                  color={colors.grey[100]}
                  fontWeight={"700"}
                  variant="h6"
                >
                  Adjustment Details
                </Typography>
              )}
            </Grid>
            <Grid container mt={1.5} xs={6} spacing={3}>
              <form>
                <Grid container direction={"column"}>
                  <Grid container xs={26} alignItems={"center"} spacing={3}>
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Dealer
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <TextField
                        margin="dense"
                        label="Search by Name / Code"
                        type="text"
                        name="dealer"
                        fullWidth
                        inputProps={{ style: { height: "20px" } }}
                        value={formData.dealer}
                        onChange={handleInputChange}
                        error={Boolean(errors.dealer)}
                        helperText={errors.dealer}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton>
                                <Search onClick={dealerSearchIconClick} />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    xs={26}
                    alignItems={"center"}
                    spacing={3}
                    mt={0.5}
                  >
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Type
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <FormControl
                        variant="outlined"
                        fullWidth
                        error={!!errors.type}
                      >
                        <StyledInputLabel id="demo-simple-select-outlined-label">
                          Select Option
                        </StyledInputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          name="type"
                          //value={selectedValue}
                          // onChange={handleTypeDropdownChange}
                          label="Type"
                          inputProps={{ style: { height: "20px" } }}
                          fullWidth
                          value={formData.type}
                          onChange={handleInputChange}
                          error={Boolean(errors.type)}
                          helperText={errors.type}
                          MenuProps={{ PaperProps: { style: dropdownStyle } }} // Apply styles to the dropdown menu
                        >
                          {CONSTANT.typeOptions.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                              {" "}
                              {option.label}{" "}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{errors.type}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    xs={26}
                    alignItems={"center"}
                    spacing={3}
                    mt={0.5}
                  >
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Description
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <FormControl
                        variant="outlined"
                        fullWidth
                        error={!!errors.description}
                      >
                        <StyledInputLabel id="demo-simple-select-outlined-label">
                          Select Description
                        </StyledInputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          name="description"
                          //value={selectedValue}
                          // onChange={handleTypeDropdownChange}
                          label="Description"
                          inputProps={{ style: { height: "20px" } }}
                          fullWidth
                          value={formData.description}
                          onChange={handleInputChange}
                          error={Boolean(errors.description)}
                          helperText={errors.description}
                          MenuProps={{ PaperProps: { style: dropdownStyle } }} // Apply styles to the dropdown menu
                        >
                          {CONSTANT.descriptionOptions.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                              {" "}
                              {option.label}{" "}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>{errors.description}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container xs={26} alignItems={"center"} spacing={3}>
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Amount
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <TextField
                        margin="dense"
                        label="Amount"
                        type="text"
                        name="amount"
                        inputProps={{ maxLength: 10 }}
                        maxLength={10}
                        fullWidth
                        value={formData.amount}
                        onChange={handleInputChange}
                        error={Boolean(errors.amount)}
                        helperText={errors.amount}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    xs={26}
                    alignItems={"center"}
                    spacing={3}
                    pb={1}
                  >
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Posting
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <FormControl component="fieldset" error={!!errors.option}>
                        <RadioGroup
                          aria-label="schedule"
                          name="option"
                          value={formData.option}
                          onChange={handleInputChange}
                          error={Boolean(errors.option)}
                          helperText={errors.option}
                          row // Aligns radio buttons horizontally
                        >
                          <FormControlLabel
                            value="scheduled"
                            control={<Radio />}
                            label="Scheduled"
                          />
                          <FormControlLabel
                            value="posted"
                            control={<Radio />}
                            label="Immediate"
                          />
                          {/* <FormControlLabel
                            value="cancelled"
                            control={<Radio />}
                            label="Cancelled"
                          /> */}
                        </RadioGroup>
                        <FormHelperText>{errors.option}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container xs={26} alignItems={"center"} spacing={3}>
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Date
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        inputProps={{ style: { height: "20px" } }}
                        margin="dense"
                        label="Date"
                        type="text"
                        name="date"
                        fullWidth
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton>
                                <DateRange onClick={chooseDateOptionClicked} />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        value={selectedDate}
                        onChange={handleInputChange}
                        error={Boolean(errors.date)}
                        helperText={errors.date}
                      />
                    </Grid>
                  </Grid>

                  <Grid container xs={26} alignItems={"center"} spacing={3}>
                    <Grid item xs={2}>
                      <Typography
                        color={colors.grey[100]}
                        fontWeight={"500"}
                        variant="h7"
                        sx={{ textAlign: "right" }}
                      >
                        Reference
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <TextField
                        margin="dense"
                        label="e.g. (YA_XXXXXX)"
                        type="text"
                        name="refrenceNo"
                        inputProps={{
                          style: { height: "20px" },
                          maxLength: 50,
                        }}
                        fullWidth
                        value={formData.refrenceNo}
                        onChange={handleInputChange}
                        error={Boolean(errors.refrenceNo)}
                        helperText={errors.refrenceNo}
                      />
                    </Grid>
                  </Grid>
                  {/* 
                  { editAllowed === null || editAllowed === true  ? (
  ) : (
    ""
  )} */}
                  <Stack
                    direction="row"
                    pt={2}
                    spacing={2}
                    mr={15}
                    justifyContent={"right"}
                  >
                    {flowProp === "0" ? (
                      <CustomButton
                        btnBG={colors.primary[900]}
                        btnColor={colors.grey[100]}
                        btnTxt={"CANCEL ADJUSTMENT"}
                        btnBorder={"1px solid" + colors.primary[800]}
                        onClick={cancelAdjustment}
                      ></CustomButton>
                    ) : (
                      ""
                    )}
                    <CustomButton
                      btnBG={colors.primary[100]}
                      btnColor={colors.grey[900]}
                      btnTxt={"SAVE"}
                      btnBorder={"1px solid" + colors.primary[100]}
                      onClick={handleSubmit}
                    ></CustomButton>
                  </Stack>
                </Grid>

                {/* Add more fields as needed */}
              </form>
            </Grid>
          </Grid>

          {/* Form Filter */}
        </Grid>
      </SnackbarProvider>
    </Box>
  );
};

export default AddAdjustments;
